import React, { Fragment } from "react";
import { SNETFooter } from "shared/dist/components";
import { FooterData } from "./footerContent";
import Header from "../Components/Header";
import Box from "@mui/material/Box";
import classes from "./HOC.module.css";

const withLightHeaderAndFooter = (Component) => {
    return (props) => {
        return (
            <Fragment>
                <Header />
                <Box className={classes.componentsContainer}>
                    <Component {...props} />
                </Box>
                <SNETFooter data={FooterData} />
            </Fragment>
        );
    };
};

export default withLightHeaderAndFooter;
